import { Component, ReactNode } from 'react';
import ReactDOM from 'react-dom';

interface PortalProps {
  id: string;
  children?: ReactNode;
}

export default class Portal extends Component<PortalProps> {
  private el: HTMLDivElement;
  private root: HTMLElement | null;

  constructor(props: PortalProps) {
    super(props);
    this.el = document.createElement('div');
    this.root = document.getElementById(this.props.id);
  }

  componentDidMount() {
    if (this.root) {
      this.root.appendChild(this.el);
    }
  }

  componentWillUnmount() {
    if (this.root && this.el.parentNode === this.root) {
      this.root.removeChild(this.el);
    }
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}
